import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelListUpgradablePlanPriceContainer = styled.div<React.CSSProperties>`
  // bottom: ${36 * Screen.widthRatio}px;
  display: flex;
  flex-direction: column;
  // position: absolute;
  // left: ${1458 * Screen.widthRatio}px;
`;

export default ChannelListUpgradablePlanPriceContainer;
